

module.exports = function($) {
    var newCarousel 	= jQuery('[data-carousel-type]');

    return {
        init: init
    };

    function init() {
        makeCarousel();
    }

    // set up carousels
    function makeCarousel() {

        $.each(newCarousel, function() {

            // var sliderType = $(this).data('carousel-type');
            var slides = $('.carousel__slides', this);

            // defaults
            var slideOptions = {
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000,
                cssEase: 'cubic-bezier(0.4, 0, 0.6, 1)',
                dots: true,
                fade: true,
                infinite: true,
                speed: 1200,
                swipeToSlide: false
            };

            // init slick slider with options
            slides.slick(slideOptions);

        });
    }

};
